'use client';
import { ReactNode, useEffect, useRef, useState } from "react";

export function Marquee({
    children,
    className,
    speed,
    gap = 0
}: {
    children: ReactNode
    className?: string
    speed?: {
        desktop: number,
        mobile: number
    },
    gap?: number
}) {
    const marqueeRef = useRef<HTMLDivElement>(null);
    const childrenRef = useRef<HTMLDivElement | null>(null);
    const windowWidth = useRef<number>(0);
    const [transformWidth, setTransformWidth] = useState('');
    // 循环渲染倍数
    const loopCount = 5;
    function computeTransformWidth() {
        if (childrenRef.current && marqueeRef.current) {
            if (windowWidth.current === innerWidth) {
                return
            }
            windowWidth.current = innerWidth;
            const w = parseFloat(getComputedStyle(childrenRef.current).width);
            setTransformWidth(`-${(w + gap) * loopCount}px`)
        }
    }
    useEffect(() => {
        if (childrenRef.current) {
            document.fonts.ready.finally(() => {
                computeTransformWidth()
            })
            setTimeout(() => {
                computeTransformWidth()
            }, 2000);
        }
        window.addEventListener('resize', computeTransformWidth);
        return () => {
            window.removeEventListener('resize', computeTransformWidth);
        }
    }, [childrenRef]);


    return (
        <div className={`marquee-base-container ${className}`}>
            <div ref={marqueeRef} className={`marquee-content ${transformWidth ? 'startAnimation' : ''}`} style={{
                '--transform-width': transformWidth,
                '--animation-desktop': `${(speed?.desktop || 3) * loopCount}s`,
                '--direction-mob': `${(speed?.mobile || 5) * loopCount}s`,
            } as React.CSSProperties}>
                <div className="children" ref={childrenRef}>
                    {children}
                </div>
                {
                    Array.from({ length: loopCount + 5 }).map((_, index) => (
                        <div className="children" key={index}>
                            {children}
                        </div>
                    ))
                }
            </div>
        </div>
    )
}